// pdf-settings.service.ts
import { Injectable } from '@angular/core';

export interface PdfViewSettings {
  doctorFullName: {
    latin: boolean;
    arab: boolean;
  };
  doctorPhone: {
    latin: boolean;
    arab: boolean;
  };
  doctorAddress: {
    latin: boolean;
    arab: boolean;
  };
  doctorSpeciality: {
    latin: boolean;
    arab: boolean;
  };
  doctorCnam: boolean;
  date: boolean;
  footer: boolean; // Ajout du footer
  signature:boolean;
  isChecked: boolean; // Ajout de isChecked
}

@Injectable({
  providedIn: 'root'
})
export class PdfSettingsService {
  private readonly SETTINGS_KEY = 'pdfViewSettings';

  // Paramètres par défaut avec footer et isChecked
  private defaultSettings: PdfViewSettings = {
    doctorFullName: {
      latin: true,
      arab: true
    },
    doctorPhone: {
      latin: true,
      arab: true
    },
    doctorAddress: {
      latin: true,
      arab: true
    },
    doctorSpeciality: {
      latin: true,
      arab: true
    },
    doctorCnam: true,
    date: true,
    signature:true,
    footer: true, // Valeur par défaut pour footer
    isChecked: true // Valeur par défaut pour isChecked
  };

  constructor() {}

  // Charger les paramètres depuis le localStorage
  getSettings(): PdfViewSettings {
    try {
      const stored = localStorage.getItem(this.SETTINGS_KEY);
      if (stored) {
        return { ...this.defaultSettings, ...JSON.parse(stored) };
      }
    } catch (error) {

    }
    return this.defaultSettings;
  }

  // Sauvegarder les paramètres dans le localStorage
  saveSettings(settings: PdfViewSettings): void {
    try {
      localStorage.setItem(this.SETTINGS_KEY, JSON.stringify(settings));
    } catch (error) {
    }
  }

  // Réinitialiser aux paramètres par défaut
  resetSettings(): void {
    try {
      localStorage.removeItem(this.SETTINGS_KEY);
    } catch (error) {
    }
  }

  // Sauvegarder uniquement le footer
  saveFooter(footer: boolean): void {
    const currentSettings = this.getSettings();
    currentSettings.footer = footer;
    this.saveSettings(currentSettings);
  }

  // Sauvegarder uniquement isChecked
  saveIsChecked(isChecked: boolean): void {
    const currentSettings = this.getSettings();
    currentSettings.isChecked = isChecked;
    this.saveSettings(currentSettings);
  }

  // Obtenir les paramètres par défaut
  getDefaultSettings(): PdfViewSettings {
    return { ...this.defaultSettings };
  }
}